import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'aside-right',
  templateUrl: './aside-right.component.html',
  styleUrls: ['./aside-right.component.sass']
})
export class AsideRightComponent implements OnInit {
  @Input() name: string;
  @Input() content: string;
  @Input() background: boolean;

  constructor() { }

  ngOnInit() {
  }

}
